module.exports = __webpack_public_path__ + "img/2.a92ebc62.png";